export default __webpack_public_path__ + "static/media/chrome-logo.a6796a63.png";